import { useContext } from 'react';
import { ExperimentationContext } from './experimentation-context';
/**
 * useFeatures()
 * Hook for accessing features in context
 * @param features
 * @returns
 */
export const useFeatures = features => {
  const {
    featureVariantAssignments: providerFeatureVariantAssignments,
    isLoading: providerIsLoading
  } = useContext(ExperimentationContext);
  const featureVariantAssignments = new Map();
  const missingFeatures = [];
  for (const feature of features) {
    if (providerFeatureVariantAssignments.has(feature)) {
      featureVariantAssignments.set(feature, providerFeatureVariantAssignments.get(feature));
    } else {
      missingFeatures.push(feature);
    }
  }

  // Warn if any features are missing.
  if (missingFeatures.length > 0) {
    // eslint-disable-next-line no-console
    console.warn(`The following feature variant assignments were not provided; please add them to an ExperimentationProvider: ${missingFeatures}`);
  }
  return {
    isLoading: providerIsLoading,
    featureVariantAssignments
  };
};
//# sourceMappingURL=use-features.js.map